import { serializeTokens } from './tokens'
import { SerializedFarmConfig } from './types'

const serializedTokens = serializeTokens()

const farms: SerializedFarmConfig[] = [
  /**
   * These 3 farms (PID 0, 251, 252) should always be at the top of the file.
   */
   {
    pid: 0,
    lpSymbol: 'GET',
    lpAddresses: {
      97: '0x9C21123D94b93361a29B2C2EFB3d5CD8B17e0A9e',
      56: '0x119207c59b195BA0869Dc93b725fDF4215C99A6C',
    },
    token: serializedTokens.syrup,
    quoteToken: serializedTokens.wbnb,
  },
  {
    pid: 1,
    lpSymbol: 'GET-BNB LP',
    lpAddresses: {
      97: '0x3ed8936cAFDF85cfDBa29Fbe5940A5b0524824F4',
      56: '0x223C81c87538b50EB670a68cAa1C69D26D067C49',
    },
    token: serializedTokens.cake,
    quoteToken: serializedTokens.wbnb,
  }
  ,
  {
    pid: 3,
    lpSymbol: 'LOOP-BNB LP',
    lpAddresses: {
      97: '',
      56: '0x204c5311b9F040D40425C0ce8b5BdDAE1CB50974',
    },
    token: serializedTokens.loop,
    quoteToken: serializedTokens.wbnb,
  }
  ,
  {
    pid: 4,
    lpSymbol: 'LSWAP-BNB LP',
    lpAddresses: {
      97: '',
      56: '0x49e6B169B1042FD210248bE252A69245BE282c9a',
    },
    token: serializedTokens.lswap,
    quoteToken: serializedTokens.wbnb,
  }
  ,
  {
    pid: 5,
    lpSymbol: 'APT-BNB LP',
    lpAddresses: {
      97: '',
      56: '0x34182c6B5B0B1c24525C9629575A492B4E1000F1',
    },
    token: serializedTokens.apt,
    quoteToken: serializedTokens.wbnb,
  }

  ,
  {
    pid: 2,
    lpSymbol: 'BUSD-BNB LP',
    lpAddresses: {
      97: '',
      56: '0x58F876857a02D6762E0101bb5C46A8c1ED44Dc16',
    },
    token: serializedTokens.busd,
    quoteToken: serializedTokens.wbnb,
  }
  
 
 
]

export default farms
